import React from 'react'
import { NavLink } from 'react-router-dom';

const Footer = () => {
    return (
        <footer>

            <div className="container">
                <div className="flex flex-wrap gap-5">
                    <div className="w-full xl:flex-1 md:w-1/2 ">
                        <div className="header">/ Robustik</div>
                        <ul>
                            <li><NavLink to="/" data-text="Home" >Home</NavLink></li>
                            {/* <li><NavLink to="/work" data-text="Work" >Work</NavLink></li> */}
                            <li><NavLink to="/about" data-text="About" >About</NavLink></li>
                            <li><NavLink to="/contact" data-text="Contact" >Contact</NavLink></li>
                        </ul>
                    </div>

                    <div className="xl:flex-1 md:w-2/6 mt-15 md:mt-0">
                        <div className="header">/ Serices</div>
                        <ul>
                            <li><NavLink to="/services/brand-building" data-text="Brand Building" >Brand Building</NavLink></li>
                            <li><NavLink to="/services/web-ui-ux-design" data-text="Web & UI/UX Design" >Web & UI/UX Design</NavLink></li>
                            <li><NavLink to="/services/web-development-e-commerce" data-text="Web Development & E-Commerce" >Web Development &<br /> E-Commerce</NavLink></li>

                            <li><NavLink to="/services/marketing-collateral" data-text="Marketing Collateral">Marketing Collateral</NavLink></li>
                            {/* <li><NavLink to="/services/motion-graphics" data-text="Motion Graphics" >Motion Graphics</NavLink></li> */}
                        </ul>
                    </div>
                    <div className="xl:flex-1 md:w-2/6 mt-15 md:mt-0">
                        <div className="header">/ Resources</div>
                        <ul>
                            <li><NavLink to="/privacy-policy" data-text="Privacy Policy" >Privacy Policy</NavLink></li>
                            <li><NavLink to="/refund-policy" data-text="Refund Policy" >Refund Policy</NavLink></li>
                            <li><NavLink to="/terms-conditions" data-text="Terms & Conditions" >Terms & Conditions</NavLink></li>
              
                        </ul>
                    </div>

                    <div className="w-full xl:flex-1  mt-15 xl:mt-0">
                        <div className="header">/ Contact</div>
                        {/* <div className="fs-30 text-primary">Say Hello</div>
                        <div className="fs-20 mt-3"><span className="font-normal">Don’t hesitate to ping us</span> <span className="opacity-50">if you have any questions or a willing to contact us in any matter other than</span></div> */}
                        <div className='flex flex-wrap mt-5 justify-between '>

                            <div className="w-full mb-5">
                                <div className="opacity-50 fs-16">Address</div>
                                <div>613 West Park Avenue, UNIT B 01, <br />Libertyville, IL 60048</div>
                            </div>
                            <div className="w-full mb-5">
                                <div className="opacity-50 fs-16">Phone</div>
                                <div><a href="tel:+16592259107" className="fs-20 native">(+1) 659 225 9107</a></div>
                            </div>
                            <div className="w-full">
                                <div className="opacity-50 fs-16  xl:mt-0">Email</div>
                                <div><a href="mailto:contact@robustik.com" className="fs-20 native" >contact@robustik.com</a></div>
                            </div>
                        </div>
                        <div className='flex flex-wrap mt-10 gap-4'>
                            <button name="btnFacebook" onClick={() => window.open("https://www.facebook.com/robustik", "_blank")}><div className='font-normal'>Facebook</div></button>
                            <button name="btnInstagram" onClick={() => window.open("https://www.instagram.com/robustik.studio", "_blank")}><div className='font-normal'>Instagram</div></button>
                            {/* <button name="btnBehance"><div className='font-normal'>Behance</div></button> */}

                        </div>

                    </div>
                </div>

                <div className="flex justify-between align-center mt-10 copy-right">
                    <div className="">©2026 Robustik. All rights reserved.
                        
                    </div>

                   


                    <div className='flex items-end payment-partner'>
                        <div className='relative'>
                            <div className="fs-12 text-right absolute top-0 right-0">Payment Partner</div>
                            <a href="https://www.thenexiontech.com/" target="_blank" rel="noopener noreferrer" className="native -my-3 the-nexion-tech">
                                <img src="/assets/img/payment-partner.webp" alt="TheNexionTech" width="145px" height="auto" />
                            </a>

                        </div>
                     
                     
                        {/* <div>
                            <a href="//www.dmca.com/Protection/Status.aspx?ID=69e015ce-33a5-45d2-b104-147e141ad0f9" title="DMCA.com Protection Status" className="dmca-badge ml-5 native" target="_blank"> <img src ="https://images.dmca.com/Badges/dmca-badge-w150-2x1-02.png?ID=69e015ce-33a5-45d2-b104-147e141ad0f9" width="70px" alt="DMCA.com Protection Status" /></a>  <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"> </script>
                        </div> */}

                    
                    </div>
                </div>
            </div>

            <div className="logo-maqruee-wrapper">
                <div className="logo-marquee">
                    <img src="/assets/img/footer-logo.webp" alt="Robustik" width="auto" height="100%" />
                    <img src="/assets/img/footer-logo.webp" alt="Robustik" width="auto" height="100%" />
                </div>
            </div>
        </footer>
    )
}

export default Footer
